import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../../comun/Modal';

const Procedimientos = () => {
    const [procedimientos, setProcedimientos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    // Modal y Formulario
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        procedimiento_recomendado: '',
        en_que_consiste: '',
        como_se_realiza: '',
        beneficios: '',
        riesgos_frecuentes: '',
        riesgos_graves: '',
        alternativas: '',
        manejo_posterior: '',
        consecuencias_no_realizar: '',
        duracion: ''
    });

    const fetchProcedimientos = async () => {
        try {
            setLoading(true);
            const response = await api.get('/api/clinical-records/procedures/');
            setProcedimientos(response.data.results || response.data || []);
        } catch (err) {
            console.error('Error fetching procedimientos:', err);
            setError('Error al cargar la lista de procedimientos.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProcedimientos();
    }, []);

    const handleOpenModal = (proc = null) => {
        if (proc) {
            setEditingId(proc.id);
            setFormData({
                name: proc.name,
                procedimiento_recomendado: proc.procedimiento_recomendado || '',
                en_que_consiste: proc.en_que_consiste || '',
                como_se_realiza: proc.como_se_realiza || '',
                beneficios: proc.beneficios || '',
                riesgos_frecuentes: proc.riesgos_frecuentes || '',
                riesgos_graves: proc.riesgos_graves || '',
                alternativas: proc.alternativas || '',
                manejo_posterior: proc.manejo_posterior || '',
                consecuencias_no_realizar: proc.consecuencias_no_realizar || '',
                duracion: proc.duracion || ''
            });
        } else {
            setEditingId(null);
            setFormData({ 
                name: '',
                procedimiento_recomendado: '', en_que_consiste: '', como_se_realiza: '',
                beneficios: '', riesgos_frecuentes: '', riesgos_graves: '',
                alternativas: '', manejo_posterior: '', consecuencias_no_realizar: '', duracion: ''
            });
        }
        setShowModal(true);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (editingId) {
                await api.patch(`/api/clinical-records/procedures/${editingId}/`, formData);
            } else {
                await api.post('/api/clinical-records/procedures/', formData);
            }
            setShowModal(false);
            fetchProcedimientos();
        } catch (err) {
            console.error('Error saving procedimiento:', err);
            alert('Error al guardar el procedimiento.');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar este procedimiento?')) return;
        try {
            await api.delete(`/api/clinical-records/procedures/${id}/`);
            fetchProcedimientos();
        } catch (err) {
            console.error('Error deleting procedimiento:', err);
            alert('Error al eliminar el procedimiento.');
        }
    };

    const styles = {
        container: { padding: '2rem', backgroundColor: '#f8f9fb', minHeight: '100vh' },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' },
        title: { margin: 0, fontSize: '1.75rem', color: '#1a1a2e', fontWeight: '800' },
        buttonPrimary: {
            padding: '0.75rem 1.5rem', borderRadius: '8px', backgroundColor: '#002b5e',
            color: '#fff', border: 'none', fontWeight: '700', cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,43,94,0.2)'
        },
        table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
        th: { padding: '1rem', textAlign: 'left', backgroundColor: '#f1f5f9', color: '#475569', fontWeight: '700' },
        td: { padding: '1rem', borderBottom: '1px solid #e2e8f0', color: '#334155' },
        actionBtn: { background: 'none', border: 'none', cursor: 'pointer', margin: '0 5px', fontSize: '1.2rem' },
        formGroup: { marginBottom: '1rem' },
        label: { display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#1e293b', fontSize: '0.9rem' },
        input: { width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const uploadData = new FormData();
        uploadData.append('file', file);

        try {
            setLoading(true);
            const response = await api.post('/api/clinical-records/procedures/import-excel/', uploadData, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            alert(response.data.message || '¡Procedimientos importados correctamente!');
            fetchProcedimientos();
        } catch (err) {
            console.error('Error importing excel:', err);
            alert('Error al importar el archivo Excel: ' + (err.response?.data?.error || err.message));
        } finally {
            setLoading(false);
            e.target.value = ''; // Reset input
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div>
                    <h1 style={styles.title}>Plantillas de Procedimientos</h1>
                    <p style={{ margin: '0.5rem 0 0', color: '#64748b' }}>Gestione las plantillas para los consentimientos informados</p>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <label style={{ ...styles.buttonPrimary, backgroundColor: '#10b981', cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center' }}>
                        <i className="bi bi-file-earmark-excel me-2"></i> Importar Excel
                        <input type="file" accept=".xlsx, .xls, .csv" style={{ display: 'none' }} onChange={handleFileUpload} />
                    </label>
                    <button style={styles.buttonPrimary} onClick={() => handleOpenModal()}>
                        + Nuevo Procedimiento
                    </button>
                </div>
            </div>

            {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}

            {loading ? (
                <p>Cargando procedimientos...</p>
            ) : (
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Nombre del Procedimiento</th>
                            <th style={styles.th}>Duración</th>
                            <th style={styles.th}>En qué consiste (resumen)</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {procedimientos.map(proc => (
                            <tr key={proc.id}>
                                <td style={styles.td}><strong>{proc.name}</strong></td>
                                <td style={styles.td}>{proc.duracion || '-'}</td>
                                <td style={styles.td}>
                                    {proc.en_que_consiste ? (proc.en_que_consiste.substring(0, 50) + '...') : '-'}
                                </td>
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    <button style={{ ...styles.actionBtn, color: '#3b82f6' }} onClick={() => handleOpenModal(proc)} title="Editar">
                                        <i className="bi bi-pencil-square"></i>
                                    </button>
                                    <button style={{ ...styles.actionBtn, color: '#ef4444' }} onClick={() => handleDelete(proc.id)} title="Eliminar">
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {procedimientos.length === 0 && (
                            <tr>
                                <td colSpan="3" style={{ ...styles.td, textAlign: 'center', color: '#64748b' }}>
                                    No hay procedimientos registrados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}

            <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={editingId ? 'Editar Procedimiento' : 'Nuevo Procedimiento'}>
                <form onSubmit={handleSave} style={{ minWidth: '600px', maxHeight: '75vh', overflowY: 'auto', paddingRight: '10px' }}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Nombre del Procedimiento (Interno)</label>
                        <input type="text" style={styles.input} required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="Ej: Exodoncia simple" />
                    </div>

                    <div style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid #e2e8f0' }}>
                        <h4 style={{ color: '#002b5e', marginBottom: '1rem', fontSize: '1.1rem' }}>Campos del Consentimiento Informado</h4>
                        
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Nombre del Procedimiento Recomendado</label>
                            <input type="text" style={styles.input} value={formData.procedimiento_recomendado} onChange={e => setFormData({ ...formData, procedimiento_recomendado: e.target.value })} placeholder="Ej: Exodoncia simple de pieza dental" />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Duración Estimada</label>
                            <input type="text" style={styles.input} value={formData.duracion} onChange={e => setFormData({ ...formData, duracion: e.target.value })} placeholder="Ej: 30–45 min" />
                        </div>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>¿En qué consiste?</label>
                                <textarea style={styles.input} rows="2" value={formData.en_que_consiste} onChange={e => setFormData({ ...formData, en_que_consiste: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>¿Cómo se realiza?</label>
                                <textarea style={styles.input} rows="2" value={formData.como_se_realiza} onChange={e => setFormData({ ...formData, como_se_realiza: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Beneficios</label>
                                <textarea style={styles.input} rows="2" value={formData.beneficios} onChange={e => setFormData({ ...formData, beneficios: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Riesgos Frecuentes (Poco graves)</label>
                                <textarea style={styles.input} rows="2" value={formData.riesgos_frecuentes} onChange={e => setFormData({ ...formData, riesgos_frecuentes: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Riesgos Poco Frecuentes (Graves)</label>
                                <textarea style={styles.input} rows="2" value={formData.riesgos_graves} onChange={e => setFormData({ ...formData, riesgos_graves: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Alternativas</label>
                                <textarea style={styles.input} rows="2" value={formData.alternativas} onChange={e => setFormData({ ...formData, alternativas: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Manejo Posterior</label>
                                <textarea style={styles.input} rows="2" value={formData.manejo_posterior} onChange={e => setFormData({ ...formData, manejo_posterior: e.target.value })} />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Consecuencias si no se realiza</label>
                                <textarea style={styles.input} rows="2" value={formData.consecuencias_no_realizar} onChange={e => setFormData({ ...formData, consecuencias_no_realizar: e.target.value })} />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '1.5rem' }}>
                        <button type="button" onClick={() => setShowModal(false)} style={{ padding: '0.75rem 1.5rem', borderRadius: '8px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
                        <button type="submit" style={styles.buttonPrimary}>Guardar Procedimiento</button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Procedimientos;
